import {
  JumbotronStyled,
  ContentJumbotron,
  ShadowCapa,
} from "./Jumbotrom.styled";
import { JumbotromProps } from "../../Models/Jumbotrom";

const Jumbotron = (props: JumbotromProps) => {
  const { image, children, align, imageResponsive, heightResponsive } = props;
  return (
    <JumbotronStyled
      $img={image}
      $imageResponsive={imageResponsive}
      $heightResponsive={heightResponsive}
    >
      <ShadowCapa />
      <ContentJumbotron $align={align}>{children}</ContentJumbotron>
    </JumbotronStyled>
  );
};

export default Jumbotron;
